import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { GraphDotnetService, graphql, PowerBiEmbedConfig, VolumeTimelineReportRow } from 'app/shared/graph';


@Injectable({ providedIn: 'root' })
export class PowerBiReportService {
    private readonly graphDotnetService = inject(GraphDotnetService);


    getEmbedConfig(): Observable<PowerBiEmbedConfig> {
        return this.graphDotnetService.query(graphql`
                query {
                    powerBiEmbedConfig {
                        reportId
                        embedUrl
                        token
                        expiration
                    }
                }
            `
        ).pipe(
            map(response => {
                if (!response.powerBiEmbedConfig) {
                    throw new Error('Graph returned no Power BI embed config.');
                }
                return response.powerBiEmbedConfig;
            })
        );
    }
}

